(function () {
  var REQUIRED_FIELDS = ['prenom', 'nom', 'email', 'commande', 'confirm'];

  function initRetractationForm(root) {
    var formWrap = root.querySelector('.retractation-form');
    var confirmWrap = root.querySelector('.retractation-confirm-wrap');
    var form = root.querySelector('form');
    var resetBtn = root.querySelector('.retractation-confirm__reset');
    if (!form) return;

    var submitBtn = form.querySelector('.retractation-form__submit');
    var endpoint = form.dataset.endpoint;

    var i18n = {
      duplicate: form.dataset.i18nDuplicate || 'Une demande de rétractation existe déjà pour cette commande.',
      notFound: form.dataset.i18nNotFound || "Aucune commande ne correspond à ce numéro de commande et à cette adresse email.",
      validation: form.dataset.i18nValidation || 'Merci de vérifier les champs du formulaire : un champ est manquant, vide ou trop long.',
      unauthorized: form.dataset.i18nUnauthorized || 'Une erreur technique est survenue, merci de réessayer plus tard.',
      unavailable: form.dataset.i18nUnavailable || 'Le service est momentanément indisponible, merci de réessayer dans quelques instants.',
      generic: form.dataset.i18nGeneric || 'Une erreur est survenue (code {{code}}), merci de réessayer.',
      network: form.dataset.i18nNetwork || 'Impossible de contacter le service, merci de vérifier votre connexion et réessayer.'
    };

    function field(name) {
      return form.querySelector('[name="' + name + '"]');
    }

    function setError(name, hasError) {
      var input = field(name);
      if (input) input.setAttribute('aria-invalid', hasError ? 'true' : 'false');
      if (name === 'confirm') {
        var wrapper = input ? input.closest('.retractation-form__confirm-checkbox') : null;
        if (wrapper) wrapper.classList.toggle('is-invalid', !!hasError);
      }
      var errorEl = form.querySelector('[data-error-for="' + name + '"]');
      if (errorEl) errorEl.classList.toggle('is-visible', !!hasError);
    }

    function highlightField(name, hasError) {
      var input = field(name);
      if (input) input.setAttribute('aria-invalid', hasError ? 'true' : 'false');
    }

    function setApiError(message) {
      var errorEl = form.querySelector('[data-error-for="api"]');
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.classList.toggle('is-visible', !!message);
    }

    function buildPayload() {
      var payload = {
        reference: field('commande').value.trim(),
        nom: field('nom').value.trim(),
        prenom: field('prenom').value.trim(),
        email: field('email').value.trim()
      };
      var tel = field('tel').value.trim();
      var motif = field('motif').value.trim();
      if (tel) payload.telephone = tel;
      if (motif) payload.motif = motif;
      return payload;
    }

    function extractValidationMessage(data) {
      if (data && Array.isArray(data.details) && data.details.length) {
        return data.details.map(function (d) { return d.message; }).filter(Boolean).join(' ');
      }
      if (data && typeof data.message === 'string') return data.message;
      if (typeof data === 'string') return data;
      return '';
    }

    function showConfirmation(data, payload) {
      var refValue = data && typeof data === 'object' ? data.id : data;
      var now = new Date();
      var dateStr = now.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) +
        ' à ' + now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

      confirmWrap.querySelector('[data-summary="ref"]').textContent = '#' + refValue;
      confirmWrap.querySelector('[data-summary="dateStr"]').textContent = dateStr;
      confirmWrap.querySelector('[data-summary="fullname"]').textContent = payload.prenom + ' ' + payload.nom;
      confirmWrap.querySelector('[data-summary="email"]').textContent = payload.email;
      confirmWrap.querySelector('[data-summary="commande"]').textContent = payload.reference;

      var motifRow = confirmWrap.querySelector('[data-summary-row="motif"]');
      motifRow.hidden = !payload.motif;
      if (payload.motif) confirmWrap.querySelector('[data-summary="motif"]').textContent = payload.motif;

      var telRow = confirmWrap.querySelector('[data-summary-row="tel"]');
      telRow.hidden = !payload.telephone;
      if (payload.telephone) confirmWrap.querySelector('[data-summary="tel"]').textContent = payload.telephone;

      form.reset();
      formWrap.hidden = true;
      confirmWrap.hidden = false;
      confirmWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function handleResponse(status, data, payload) {
      if (status === 200 || status === 201) {
        showConfirmation(data, payload);
        return;
      }

      if (status === 400) {
        setApiError(i18n.duplicate);
      } else if (status === 404) {
        highlightField('commande', true);
        highlightField('email', true);
        setApiError(i18n.notFound);
      } else if (status === 422) {
        setApiError(extractValidationMessage(data) || i18n.validation);
      } else if (status === 401) {
        setApiError(i18n.unauthorized);
      } else if (status === 500 || status === 502 || status === 503 || status === 504) {
        setApiError(i18n.unavailable);
      } else {
        setApiError(i18n.generic.replace('{{code}}', status));
      }
      console.error('Retractation API error', status, data);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setApiError('');

      if (!form.checkValidity()) {
        var invalids = form.querySelectorAll(':invalid');
        REQUIRED_FIELDS.forEach(function (name) {
          var input = field(name);
          setError(name, input ? !input.checkValidity() : false);
        });
        if (invalids[0]) invalids[0].focus();
        return;
      }
      REQUIRED_FIELDS.forEach(function (name) { setError(name, false); });

      var payload = buildPayload();
      submitBtn.disabled = true;

      fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var data;
            try { data = JSON.parse(text); } catch (err) { data = text; }
            return { status: res.status, data: data };
          });
        })
        .then(function (result) {
          handleResponse(result.status, result.data, payload);
        })
        .catch(function (err) {
          setApiError(i18n.network);
          console.error('Retractation API network error', err);
        })
        .finally(function () {
          submitBtn.disabled = false;
        });
    });

    ['commande', 'email'].forEach(function (name) {
      var input = field(name);
      if (!input) return;
      input.addEventListener('input', function () { highlightField(name, false); });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        REQUIRED_FIELDS.forEach(function (name) { setError(name, false); });
        setApiError('');
        confirmWrap.hidden = true;
        formWrap.hidden = false;
        formWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  document.querySelectorAll('.retractation-form-section').forEach(initRetractationForm);
})();
